// extracted by mini-css-extract-plugin
module.exports = {"imagen":"Dog_imagen__3vokB","card":"Dog_card__3ZIV8"};